





















import Priority from '@/domain/activity/entity/priority.entity';
import Assessment from '@/domain/assessment/entity/assessment';
import AssessmentService from '@/domain/assessment/service/assessment.service';
import Loading from '@/shared/loading/loading.component.vue';
import { VbSnackbarService } from 'bag-of-holding-library';
import { Vue, Component, Prop } from 'vue-property-decorator';
import AssessmentComponent from './assessment.component.vue';

@Component({
  components: {
    AssessmentComponent,
    Loading,
  },
})
class CurrentAssessmentComponent extends Vue {
  @Prop({
    type: Array,
    default: () => [],
  }) priorityItems!: Priority;

  @Prop({
    type: String,
    required: true,
  }) employeeId!: string;

  @Prop({
    type: Boolean,
    required: true,
  }) isUserLoggedIn!: boolean;

  assessment: Assessment = new Assessment();

  loading: boolean = false;

  errorMessage: string = '';

  async created() {
    this.loading = true;
    await this.getAssessmentForm();
    this.loading = false;
  }

  async getAssessmentForm() {
    try {
      this.assessment = await AssessmentService.getFormTemplateByEmployeeId(this.employeeId)
    } catch (error) {
      const { response } = (error as any)!;
      VbSnackbarService.handleHttpError(response);
      this.errorMessage = response.data.messages[0]
        || 'Erro ao buscar assessment. Entre em contato com um administrador.';
    }
  }

  handleSaved() {
    this.getAssessmentForm();
  }
}
export default CurrentAssessmentComponent;
